import { combineReducers, configureStore } from '@reduxjs/toolkit';
import notifyCounterSlice from './features/counter/notifyCounterSlice';
import userSlice from './features/authen/authenSlice';
import appSlice from './features/app/appSlice';

import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import persistStore from 'redux-persist/es/persistStore';
import thunk from 'redux-thunk';
import CU04801Slice from './features/CU/CU04801Slice';
import CU05504Slice from './features/CU/CU05504Slice';
import CU03101Slice from './features/CU/CU03101Slice';
import CU03603Slice from './features/CU/CU03603Slice';
import CU02902Slice from './features/CU/CU02902Slice';
import CU01702Slice from './features/CU/CU01702Slice';
import socketSlice from './features/app/socketSlice';
import chatCounterSlice from './features/counter/chatCounterSlice';

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, userSlice);

const rootReducers = combineReducers({
    notifyCounterSlice: notifyCounterSlice,
    chatCounterSlice: chatCounterSlice,
    socketSlice: socketSlice,
    app: appSlice,
    user: persistedReducer,
    CU04801Slice: CU04801Slice,
    CU05504Slice: CU05504Slice,
    CU03101Slice: CU03101Slice,
    CU01702Slice: CU01702Slice,
    CU03603Slice: CU03603Slice,
    CU02902Slice: CU02902Slice,
});


export const store = configureStore({
    reducer: rootReducers,
    middleware: [thunk],
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
